module.exports = __webpack_public_path__ + "static/media/footer-linear-waifu.b90fd0af.svg";